import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "serp__filters-list--container",
  class: "serp__filters-list--container q-container-fluid q-p-3 q-p-md-2 q-bg-light q-pb-1"
}

import FilterItemContainer from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItemContainer.vue";
import UsedFilterContainer from "@/components/SerpPage/FiltersContainer/UsedFilterContainer.vue";
import {storeToRefs} from "pinia";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersListContainer',
  setup(__props) {

const filtersStore = useFiltersStore();
const {getFilters, isMobileView} = storeToRefs(filtersStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)


return (_ctx: any,_cache: any) => {
  return (!_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_unref(isMobileView))
          ? (_openBlock(), _createBlock(UsedFilterContainer, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getFilters), (filter, index) => {
          return (_openBlock(), _createBlock(FilterItemContainer, {
            key: filter.field,
            filter: filter,
            "filter-collapsed": _unref(isMobileView) ? index >= 1 : index >= 3
          }, null, 8, ["filter", "filter-collapsed"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})